const selectors = {
  toggle: 'data-toggle-grid',
  large: 'data-grid-large',
  small: 'data-grid-small',
};

const options = {
  breakpoint: window.theme.sizes.small,
};

var sections = {};

class Toggle {
  constructor(toggle) {
    this.toggle = toggle;
    this.value = this.toggle.getAttribute(selectors.toggle);
    this.toggleClickFunction = (evt) => this.toggleClick(evt);

    this.init();
  }

  init() {
    this.toggle.addEventListener('click', this.toggleClickFunction);
  }

  unload() {
    this.toggle.removeEventListener('click', this.toggleClickFunction);
  }

  toggleClick() {
    const isLarge = window.innerWidth >= options.breakpoint;
    const selector = isLarge ? selectors.large : selectors.small;
    document.querySelector(`[${selector}]`).setAttribute(selector, this.value);
    if (window.lazySizes) {
      window.lazySizes.autoSizer.checkElems();
    }
  }
}

const toggleSection = {
  onLoad() {
    sections[this.id] = [];
    const buttons = this.container.querySelectorAll(`[${selectors.toggle}]`);
    buttons.forEach((button) => {
      sections[this.id].push(new Toggle(button));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((toggle) => {
      if (typeof toggle.unload === 'function') {
        toggle.unload();
      }
    });
  },
};

export default toggleSection;
